import { ITEM_STATE_PLACEHOLDER } from "../../constants";

export default ({ itemState }) => itemState === ITEM_STATE_PLACEHOLDER;
